import { MessageBar } from '@repo/ui/components';
import { OrderValidation } from 'next-common';
import { TMessageBarSeverity } from 'types';
import { IValidationToastNotification } from '../../common';
import { parseValidationError } from './FinanceWarning.utils';

export interface IFinanceWarningProps extends IValidationToastNotification {
  validationErrors: OrderValidation[];
}

export const FinanceWarning = (props: IFinanceWarningProps) => {
  return (
    <MessageBar severity={TMessageBarSeverity.ERROR} dismissible onClose={props?.onClose}>
      <h4 className="text-lg/[175%]">Problem med finansiering</h4>

      <ul>
        {props.validationErrors.map((x) => (
          <li className="text-base/[175%] font-semibold" key={x}>
            {parseValidationError(x)}
          </li>
        ))}
      </ul>
    </MessageBar>
  );
};

export const ServiceContractWarning = (props) => {
  return (
    <MessageBar severity={TMessageBarSeverity?.ERROR} dismissible onClose={props?.onClose}>
      <h4 className="text-lg/[175%]">Problem med servicekontrakten</h4>

      <ul>
        <li className="text-base/[175%] font-semibold">{props.validationErrors}</li>
      </ul>
    </MessageBar>
  );
};
